import React from 'react';
import headerImage from '../content/yoga.JPG';
import Layout from './layout';
import HeroImage from '../components/HeroImage';

const Mailing = () => {
  return (
    <Layout>
      <HeroImage headerImage={headerImage} title=''/>
      {/* Text Section */}
      <section className="flex-grow px-4 font-gordita  py-10 bg-pink text-center">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 mb-4">Join our mailing list</h2>
        <p>Visit our <a href='https://girlsclubteesside.beehiiv.com/?_gl=1*1aap82j*_gcl_au*Mjk4NjQ0MjY4LjE3ODIyNDMzMDUuMTUwOTI5Mzg0OS4xNzg1Njk5NTA4LjE3ODU3MDEwOTAuMTA5NTIwNDE4Ni4xNzg1Njk5NTA2LjE3ODU3MDEyMzI.*_ga*MTE0MDg1MzkxNC4xNzgyMjQzMzA0*_ga_E6Y4WLQ2EC*czE3ODU2OTk1MDYkbzMkZzEkdDE3ODU3MDEyMzIkajQxJGwwJGgxNDk1NDI3NTg0' className='underline hover:text-cosmopink'>Beehiiv sign up page</a> to register your email and sign up for event notifications. </p>
      </section>
    </Layout>
  );
};

export default Mailing;
